import compose from 'utils/composeEnhancer'
import useAnimationObserver from './useAnimationObserver'
import toggleSidebarStore from 'hooks/toggleSidebarStore'

export default compose(
  useAnimationObserver,
  toggleSidebarStore
)
